import {
  CAMPAIGN_ONOFF_ERROR,
  CAMPAIGN_ONOFF_LOADING,
  SET_CAMPAIGNS_ONOFF,
  CAMPAIGN_ONOFF_DATABASE_UPDATING,
  CAMPAIGN_ONOFF_DATABASE_UPDATE,
  CAMPAIGN_ONOFF_DATABASE_UPDATE_ERROR,
} from "../constants";

const initial_state = {
  loading: {
    campaign: false,
    saving: false,
  },

  errors: {
    // campaign: "Error message"
  },
  // Users
  list: [], // List of available campaigns
  isInternalUser: false,
  selectedOptions: {
    type: "",
    subType: "",
    companyCode: "",
  },
};

export default function (state = initial_state, { type, payload }) {
  const loading = state.loading;

  switch (type) {
    case CAMPAIGN_ONOFF_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case CAMPAIGN_ONOFF_DATABASE_UPDATE_ERROR:
      loading.saving = false;
      return {
        ...state,
        loading: { ...loading },
        errors: payload || { unknown: "Unknown error" },
      };

    case CAMPAIGN_ONOFF_DATABASE_UPDATING:
      loading.saving = true;
      return {
        ...state,
        loading: { ...loading },
      };

    case CAMPAIGN_ONOFF_DATABASE_UPDATE:
      loading.saving = false;
      return {
        ...state,
        loading: { ...loading },
      };

    case CAMPAIGN_ONOFF_LOADING:
      loading.campaign = true;
      return {
        ...state,
        loading: { ...loading },
      };

    case SET_CAMPAIGNS_ONOFF:
      return {
        ...state,
        loading: { ...loading, campaign: false },
        list: payload,
      };

    default:
      return state;
  }
}
